import React from 'react';
import CleaningSchedulePage from '../../components/CleaningSchedulePage';

const AdminWeeklyCleaning = () => (
  <CleaningSchedulePage
    kind="weekly-cleaning"
    title="Weekly Deep Cleaning"
    subtitle="Deep-clean schedule — complete across the week"
    iconColor="#BF5AF2"
  />
);

export default AdminWeeklyCleaning;
